var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.etiquetas.length>0)?_c('div',{staticClass:"wpb_wrapper",staticStyle:{"height":"180px","position":"relative","width":"100%"}},[_c('vue-word-cloud',{attrs:{"words":_vm.etiquetas,"color":_vm.getColor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var text = ref.text;
var weight = ref.weight;
var word = ref.word;
return [_c('div',{staticStyle:{"cursor":"pointer"},attrs:{"title":text},on:{"click":function($event){return _vm.onClick(word)}}},[_vm._v("\n                "+_vm._s(text)+"\n            ")])]}}],null,false,1594068436)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }